import { render, staticRenderFns } from "./orden.vue?vue&type=template&id=bc8a3d4a&scoped=true"
import script from "./orden.vue?vue&type=script&lang=js"
export * from "./orden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8a3d4a",
  null
  
)

export default component.exports